import DonutChartBase from './donut-chart-base';
import './donut-chart.css';

export default DonutChartBase();
